import React from 'react';
import Panel from '../../components/ui/Panel';

const FontsPage: React.FC = () => {
  return (
    <div>
      <h1 id="overview" className="text-3xl text-osrs-gold font-bold uppercase mb-4">Fonts</h1>
      <p className="text-osrs-yellow mb-8">
        Three families ship inside the package and load from the stylesheet. RuneScape, RuneScape Bold, and RuneScape Small.
      </p>

      <section id="downloads" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Downloads</h2>
        <Panel>
          <p className="text-osrs-yellow mb-4">
            You do not download the fonts separately. They are the files next to styles.css and the stylesheet points at them.
          </p>
          <p className="mb-2" style={{ fontFamily: 'RuneScape', color: '#F5E20D', fontSize: 20 }}>
            RuneScape. The quick brown fox.
          </p>
          <p className="mb-2" style={{ fontFamily: 'RuneScape Bold', color: '#E6A519', fontSize: 20 }}>
            RuneScape Bold. The quick brown fox.
          </p>
          <p style={{ fontFamily: 'RuneScape Small', color: '#F5E20D', fontSize: 16 }}>
            RuneScape Small. The quick brown fox.
          </p>
        </Panel>
      </section>

      <section id="installation" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Installation</h2>
        <Panel>
          <pre className="bg-osrs-black p-4 text-osrs-yellow overflow-x-auto">{`import 'osrs-design-system/styles.css';`}</pre>
          <p className="text-osrs-yellow mt-4">
            That one line registers the faces. Components use RuneScape for body text. There is no CDN font URL.
          </p>
        </Panel>
      </section>

      <section id="usage-guidelines" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Usage Guidelines</h2>
        <Panel>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2 ml-4">
            <li>Use RuneScape for interface text and chat.</li>
            <li>Use RuneScape Bold for window titles in your own markup.</li>
            <li>Use RuneScape Small for dense lists such as a long chat log.</li>
          </ul>
        </Panel>
      </section>
    </div>
  );
};

export default FontsPage;
